exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".flight-seg>tr>td[data-v-288c2774]{width:56.5%;height:30px}.passenger>tr>td[data-v-288c2774]{width:35%;height:30px}.booking>tr>td[data-v-288c2774]{width:32.5%;height:30px}.flight-seg[data-v-288c2774]{padding-top:2%}", ""]);

// exports
